"use client";
import { getToken } from "@/libs/auth/getToken";
import Cookies from "js-cookie";
import { useEffect } from "react";

export const useGuestUid = () => {
  useEffect(() => {
    const uid = Cookies.get("guest_uid");
    async function getSession() {
      const token = await getToken();
      if (!uid && !token) {
        const newUid = crypto.randomUUID();
        Cookies.set("guest_uid", newUid, { expires: 14 });
      }
    }

    getSession();
  }, []);
};
